import UiElement from '../../../shared/ui-element/ui-element';
import LangSwitcher from '../lang-switcher/lang-switcher';

import '../../layout/_footer.scss';
import '../../layout/_store-footer.scss';

// Fired on `document` by the CookieYes script (loaded via GTM) once the banner has loaded.
const COOKIEYES_BANNER_LOAD_EVENT = 'cookieyes_banner_load';

// Reported by CookieYes when the US State Laws (opt-out) banner template is shown.
const COOKIEYES_ACTIVE_LAW_CCPA = 'ccpa';

class Footer extends UiElement {
  ui = {
    langSwitcher: '.site-footer__lang-switcher',
    doNotSellLink: '.js-do-not-sell-link',
  };

  events = {
    [`${COOKIEYES_BANNER_LOAD_EVENT} @rootElement`]: 'toggleDoNotSellLink',
  };

  onInit() {
    if (this.ui.langSwitcher) {
      new LangSwitcher({ rootElement: this.ui.langSwitcher }).init();
    }

    // The banner may have loaded before this component was initialized.
    this.toggleDoNotSellLink();
  }

  /**
   * CCPA/CPRA "Do not sell or share my personal information" link.
   * Shown only when CookieYes applies the US (opt-out) consent law to the visitor.
   * Clicking it reopens the CookieYes opt-out center via the `cky-banner-element` class.
   */
  toggleDoNotSellLink() {
    if (!this.ui.doNotSellLink) {
      return;
    }

    const consent = window.getCkyConsent && window.getCkyConsent();

    this.ui.doNotSellLink.hidden = !consent || consent.activeLaw !== COOKIEYES_ACTIVE_LAW_CCPA;
  }
}

export default Footer;
